module.exports = __webpack_public_path__ + "static/media/about.edd8b750.png";